import { useEffect, useState } from 'react';
import { useAuth } from './useAuth';
import axios from 'axios';

interface CompanyEmployeeInfo {
  id: number;
  companyId: number;
  role: string;
  company: {
    id: number;
    companyName: string;
    status: string;
  };
}

export const useCompanyId = () => {
  const { user } = useAuth();
  const [companyId, setCompanyId] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCompanyId = async () => {
      console.log('🔍 [useCompanyId] User state:', {
        user,
        userRole: user?.userRole,
      });

      // 企業関連ユーザー（企業管理者・人事担当者・一般従業員）のみ
      if (!user || !['company_admin', 'hr', 'employee'].includes(user.userRole)) {
        console.log('🔍 [useCompanyId] User not company user or not logged in');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);

        // ユーザーの企業従業員情報を取得
        console.log('🔍 [useCompanyId] Fetching company info...');
        const response = await axios.get('/api/users/me/company');
        console.log('🔍 [useCompanyId] API Response:', response.data);

        if (response.data.success && response.data.data) {
          const companyInfo: CompanyEmployeeInfo = response.data.data;
          console.log('🔍 [useCompanyId] Company info:', companyInfo);
          setCompanyId(companyInfo.companyId);
        } else {
          console.log('🔍 [useCompanyId] No company data in response');
          setError('企業情報が見つかりません');
        }
      } catch (err: any) {
        console.error('🔍 [useCompanyId] API Error:', err);
        console.error('🔍 [useCompanyId] Error response:', err.response?.data);
        setError(err.response?.data?.message || '企業情報の取得に失敗しました');
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyId();
  }, [user]);

  return {
    companyId,
    loading,
    error,
    isCompanyUser: user ? ['company_admin', 'hr', 'employee'].includes(user.userRole) : false,
  };
};
